export enum SurveyStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft',
  TEMPLATE = 'template',
}